import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg24Recievecoin2 = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M12.6 2.23A9.77 9.77 0 0 0 2.83 12a9.76 9.76 0 0 0 9.77 9.77 9.7 9.7 0 0 0 3.65-.708.8.8 0 0 0-.6-1.484 8.1 8.1 0 0 1-3.05.592A8.16 8.16 0 0 1 4.43 12a8.17 8.17 0 0 1 8.17-8.17c1.109 0 2.185.219 3.18.637a.8.8 0 1 0 .62-1.474 9.8 9.8 0 0 0-3.8-.763m-2.836 9.205a1 1 0 0 0-.066.075zA.8.8 0 0 0 9.53 12v.028l.004.054L9.53 12a.8.8 0 0 0 .235.566l3.72 3.71a.8.8 0 0 0 1.13-1.132L12.266 12.8h8.944a.8.8 0 1 0 0-1.6h-8.949l2.355-2.354a.8.8 0 1 0-1.132-1.132z"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg24Recievecoin2$1 = Svg24Recievecoin2;

export { Svg24Recievecoin2$1 as default };
